import { OptionalProps, classes } from 'src/utils'
import { Button } from '../../../ui/button'
import {
  ComponentProps,
  ReactElement,
  cloneElement,
  isValidElement,
} from 'react'
import { Spinner } from '..'

type Props = {
  label: string
  isPrimary?: boolean
  isLoading?: boolean
  loadingLabel?: string
  disabled?: boolean
  className?: string
  size?: 'icon' | 'default' | 'sm' | 'lg'
  iconSize?: number
  iconColor?: string
} & (
  | { type: 'submit'; onClick?: undefined }
  | { type?: 'button'; onClick: () => void }
  | { type: 'menu'; onClick?: undefined }
) &
  OptionalProps<{
    icon: ReactElement<ComponentProps<'svg'>>
    iconPosition: 'left' | 'right'
  }>

const ButtonSpinner = (
  <div className="px-0.5">
    <Spinner />
  </div>
)

export function CustomButton(props: Props) {
  const disabled = props.isLoading || props.disabled

  const Icon =
    isValidElement(props.icon) &&
    cloneElement(props.icon, {
      className: classes(
        `w-${props.iconSize === undefined ? '4' : props.iconSize} h-${
          props.iconSize === undefined ? '4' : props.iconSize
        } pointer-events-none`,
        disabled
          ? props.iconColor === undefined
            ? 'text-primary'
            : props.iconColor
          : props.isPrimary
          ? 'text-white'
          : props.iconColor === undefined
          ? 'text-primary-foreground'
          : props.iconColor,
      ),
      'aria-hidden': true,
    })
  return (
    <div className="flex flex-col items-start group">
      <div className="flex w-full items-center space-x-3">
        <Button
          onClick={props.onClick}
          type={props.type === 'menu' ? 'button' : props.type}
          disabled={disabled}
          variant="outline"
          className={classes(props.className)}
          size={props.size}
        >
          {props.iconPosition === 'left' &&
            (props.isLoading ? ButtonSpinner : Icon)}

          {props.iconPosition === undefined &&
            (props.isLoading ? ButtonSpinner : null)}

          <span className="block font-semibold leading-5 capitalize truncate">
            {props.loadingLabel && props.isLoading
              ? props.loadingLabel
              : props.label}
          </span>

          {props.iconPosition === 'right' &&
            (props.isLoading ? ButtonSpinner : Icon)}
        </Button>
      </div>
    </div>
  )
}

export default CustomButton
